module.exports = __webpack_public_path__ + "static/media/pg21.9160d1f0.jpg";